import*as e from"react";import{vars as t}from"./theme.css";export{t as vars};
